import React from "react";
import { BiSun, BiMoon } from "react-icons/bi";
import { ThemeContext } from "../Context/ThemeContext";

const Toggle = () => {
  const { theme, setTheme } = React.useContext(ThemeContext);

  return (
    <div className="transition duration-500 ease-in-out rounded-full p-2">
      {theme === "dark" ? (
        <BiSun
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          className="text-gray-500 dark:text-gray-100 text-2xl cursor-pointer"
        />
      ) : (
        <BiMoon
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          className="text-gray-500 dark:text-gray-100 text-2xl cursor-pointer"
        />
      )}
    </div>
  );
};

export default Toggle;
